module.exports = __webpack_public_path__ + "static/img/Colla_Tale_4.39192d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/Colla_Tale_4.jpg
// module id = gOyL
// module chunks = 0